"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoChangesEmail = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.RoChangesEmail = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
    csa_name: typebox_1.Type.String(),
    order_number: typebox_1.Type.String(),
    service_location: typebox_1.Type.String(),
    changes_block: typebox_1.Type.String(),
});
//# sourceMappingURL=ro-changes-email.js.map